import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocumentUrl, getDocumentOpenName , getDocumentCompanySymbol} from "../API/LocalStore";
import { useDispatch } from 'react-redux';
import { setheadermenuData } from '../reducers/HeaderMenuReducer';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { userEventAPI } from "../API/Userapis";
import { GAEvenet } from "../API/GoogleAnalytics";

export default function AllPages(props) {
  const [Pdfurl, setPdfurl] = useState('');
  const [PdfName, setPdfName] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    GAEvenet();
    const doc_url = getDocumentUrl();
    if (!doc_url) navigate(-1);

    setPdfurl(encodeURI(doc_url));
    const doc_name = getDocumentOpenName();
    const company_symbol = getDocumentCompanySymbol();
    setPdfName(doc_name);

    // Track view events based on document type
    const trackingMap = {
      'Income Statement': 'company_income_statement',
      'Balance Sheet': 'company_balance_sheet',
      'Equity Statement': 'company_equity_statement',
      'Cash Flow Statement': 'company_cashflow_statement',
      'Comprehensive Statement': 'company_comprehensive_statement',
      'Notes': 'company_notes',
      'Annual Report': 'company_annual_report',
      'Financial Report': 'company_financial_report'
    };

    if (trackingMap[doc_name]) {
      userEventAPI(`${trackingMap[doc_name]}_${company_symbol}_view`);
    }
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleDownload = () => {
    if (Pdfurl) {
      const link = document.createElement('a');
      link.href = Pdfurl;
      link.download = `${PdfName || 'document'}.pdf`; // Fallback if no name
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    dispatch(setheadermenuData({ currentpath: '/financials', headerfootershow: true }));
  }, []);

  return (
    <>
      <div style={{ minHeight: "90vh" }}>
        <div className="container-fluid nopaddingcontainer mb-2">
          <div className="container card section_divider">
            <div className="row section_divider">
              <div className="col-md-6">
                <Button
                  style={{
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                    transform: "translateX(-10px)"
                  }}
                  onClick={handleBack}
                >
                  <span className="back_btn_txt2">
                    <img
                      alt="Back"
                      style={{ transform: "rotateZ(90deg)" }}
                      srcSet="/assets/icons/Dropdown.svg"
                    />{" "}
                    Back
                  </span>
                </Button>
              </div>
              <div className="col-md-6 text-right">
                {/* Download button */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  disabled={!Pdfurl}
                >
                  Download PDF
                </Button>
              </div>
            </div>
            <div
              className="row news_label_with_search_row pt-1"
              style={{ background: "#eeedef" }}
            >
              <div className="col-md-6">
                <label className="labelasheading">{PdfName}</label>
                <br />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 pb-3 pdfdocbox">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <div
                    style={{
                      border: "1px solid rgba(0, 0, 0, 0.3)",
                      height: "150vh"
                    }}
                  >
                    {Pdfurl !== "" ? <Viewer fileUrl={Pdfurl} /> : ""}
                  </div>
                </Worker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}